import { Flex, Text } from '@chakra-ui/react';
import { Icons } from '@texas/components/shared/Icons';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

interface CurrentContextHeaderProps {
  archived?: boolean;
  label: string;
  subtitle?: string;
  title: string;
  children?: ReactNode;
}

export function CurrentContextHeader({
  archived,
  label,
  subtitle,
  title,
  children,
}: CurrentContextHeaderProps) {
  const { t } = useTranslation();

  return (
    <Flex direction="column" gap={0.5} py={5}>
      <Text
        color="navigation.contextMuted"
        fontFamily="barlow"
        fontSize="11px"
        fontWeight="bold"
        letterSpacing="0.12em"
        lineHeight="14px"
      >
        {label.toUpperCase()}
      </Text>
      <Text
        color="chakra-body-text"
        fontFamily="barlow"
        fontSize="lg"
        fontWeight="extrabold"
        lineHeight="22px"
        noOfLines={2}
      >
        {title}
      </Text>
      {subtitle && (
        <Text
          color="navigation.contextMuted"
          fontFamily="instrumentSans"
          fontSize="13px"
          lineHeight="16px"
          noOfLines={1}
        >
          {subtitle}
        </Text>
      )}
      {archived && (
        <Flex
          align="center"
          alignSelf="flex-start"
          bg="status.dangerBackground"
          borderColor="status.dangerBorder"
          borderWidth="1px"
          color="status.danger"
          fontFamily="barlow"
          fontSize="11px"
          fontWeight="bold"
          gap={1.25}
          h="22px"
          letterSpacing="0.08em"
          lineHeight="13px"
          mt={1}
          px={2}
        >
          <Icons.ArchiveOutline boxSize={3.5} />
          {t('general.archived').toUpperCase()}
        </Flex>
      )}
      {children}
    </Flex>
  );
}
